import { EmptyState } from '@components/molecules/empty-state';
import {
  defaultParams,
  pageSizeOptions,
  showSizeChanger,
  dateTimeFormat,
  dateFormat,
} from '@utils/constants';
import { IDriver } from '@interfaces/idriver';
import { IMeta } from '@interfaces/imeta';
import { IVendor } from '@interfaces/ivendor';
import { companyTypeCase } from '@utils/string-case';
import { filter, tableChangeParams } from '@utils/table';
import { Table } from 'antd';
import { PaginationConfig } from 'antd/lib/table';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { formatTime } from '@utils/time';

interface IProps {
  isFetching: boolean;
  fetchDataSource: (params: any) => void;
  dataSource?: any;
  meta: IMeta;
}

interface IState {
  tableParams: any;
}

export class TableComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      tableParams: defaultParams,
    };
  }
  public componentDidMount = () => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;
    fetchDataSource(tableParams);
  };
  public onChangeTable = (pagination: PaginationConfig, filters: any, sorter: any) => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;

    const params = tableChangeParams(pagination, filters, sorter, tableParams);
    this.setState({ tableParams: params });
    fetchDataSource(params);
  };
  public render() {
    const { dataSource, isFetching, meta } = this.props;
    const tableEmptyState = <EmptyState emptyText="Data Tidak Ditemukan" />;

    const columns: any = [
      {
        title: 'Kode Supir',
        dataIndex: 'code',
        ...filter('code'),
        sorter: true,
        fixed: 'left',
        render: (text: string) => <Link to={`/driver/detail/${text}`}>{text}</Link>,
        width: 180,
      },
      {
        title: 'Nama Supir',
        dataIndex: 'fullName',
        ...filter('fullName'),
        sorter: true,
        width: 200,
      },
      {
        title: 'Vendor',
        dataIndex: 'vendor',
        ...filter('vendor'),
        render: (record: IVendor) => (
          <Link to={`/vendor/detail/${record.code}`}>
            {companyTypeCase(record.type, record.name)}
          </Link>
        ),
      },
      {
        title: 'Telepon',
        dataIndex: 'phone',
        ...filter('phone'),
        sorter: true,
      },
      {
        title: 'Alamat',
        dataIndex: 'address',
        ...filter('address'),
        sorter: true,
        ellipsis: true,
      },
      {
        title: 'Masa Berlaku SIM',
        dataIndex: 'expiryDateSIM',
        ...filter('expiryDateSIM'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateFormat) : '-'),
        width: 200,
      },
      {
        title: 'Diupdate Oleh',
        dataIndex: 'updated_by',
        ...filter('updated_by'),
        sorter: true,
        render: (text: string) => text || '-',
        width: 200,
      },
      {
        title: 'Diupdate Pada',
        dataIndex: 'updated_at',
        ...filter('updated_at'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateTimeFormat) : '-'),
        width: 200,
      },
      {
        title: 'Action',
        render: (text: any, record: IDriver) => (
          <Fragment>
            <Link to={`/driver/form/${record.code}`}>Ubah</Link>
            {/* <Divider type="vertical" />
            <Button type="link">Hapus</Button> */}
          </Fragment>
        ),
        width: 100,
      },
    ];

    return (
      <div className="bt-table">
        <Table
          size="small"
          onChange={this.onChangeTable}
          columns={columns}
          dataSource={dataSource}
          bordered={true}
          pagination={
            meta && {
              current: meta.current_page,
              pageSize: meta.per_page,
              pageSizeOptions,
              showSizeChanger,
              total: meta.total,
            }
          }
          locale={{
            emptyText: tableEmptyState,
          }}
          loading={isFetching}
          rowKey="id"
          scroll={{ x: 1500 }}
        />
      </div>
    );
  }
}

export default TableComponent;
